
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(54|76|85)|740)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
